import React from 'react';

import { Box } from '@mui/system';
import Button from '@mui/material/Button';
import AppWrapper from '@components/AppWrapper/AppWrapper';
import { useModalStyles } from '@core/myta/hooks/modalStyles';
import { useTranslation } from 'react-i18next';
import { useMytaverse } from '@providers/MytaverseProvider';

const ExternalEventPageContent = ({
  setTeleportButtonClicked,
}: {
  setTeleportButtonClicked: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const modalClasses = useModalStyles();
  const { t: translate } = useTranslation();

  const primaryButtonSx = {
    ...modalClasses.button,
    ...modalClasses.buttonPrimary,
  };

  return (
    <AppWrapper>
      <Box sx={{ mt: 4 }}>
        <Button
          sx={primaryButtonSx}
          variant="contained"
          size="large"
          onClick={() => setTeleportButtonClicked(true)}
        >
          {translate('playScreen.play')}
        </Button>
      </Box>
    </AppWrapper>
  );
};

export default ExternalEventPageContent;
